<template>
  <div id="tags-view-container" class="tags-view-container main-tabs">
    <div class="scroll-container tags-view-wrapper scrollbar">
      <div class="scrollbar__wrap" style="margin-bottom: 0.8rempx">
        <div ref="scrollbar__view" class="scrollbar__view">
          <router-link
            class="tags-view-item text-menu"
            v-for="(item, index) in tabs"
            :key="index"
            :to="item.to"
            @click.middle.native="deletetab(item)"
            @contextmenu.prevent.native="openMenu(item, $event)"
          >
            {{ item.name }}
            <span
              @click.prevent.stop="deletetab(item)"
              class="close-tab-icon"
              style=""
            >
              <i class="flaticon2-cross"></i> </span
          ></router-link>
        </div>
      </div>
      <div class="scrollbar__bar is-horizontal">
        <div class="scrollbar__thumb" style="transform: translateX(0%)"></div>
      </div>
      <div class="scrollbar__bar is-vertical">
        <div class="scrollbar__thumb" style="transform: translateY(0%)"></div>
      </div>
    </div>
    <ul
      v-show="visible"
      :style="{ left: left + 'px', top: top + 'px' }"
      class="contextmenu card bg-success text-white"
    >
      <li class="" @click="deletetab(selectedTab)">بستن تب</li>
      <li
        class="text-gray-800"
        v-if="activeTab && activeTab.path === selectedTab.to"
        @click="closeOthersTabs"
      >
        بستن تب های دیگر
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import {
  REMOVE_TAB,
  CLOSE_OTHER_TABS,
} from '@/core/services/store/activetabs.module.js';

export default {
  name: 'TagsView',
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTab: {},
      originalTabTop: 0,
      isHeaderSticky: false,
      activeTab: null,
    };
  },
  components: {},
  beforeMount() {},
  created() {
    window.addEventListener('scroll', () => {
      this.defineTabsPosition();
    });
  },

  mounted() {
    this.$nextTick(() => {
      let el = document.querySelector('.main-tabs');
      if (el) {
        this.originalTabTop = document
          .querySelector('.main-tabs')
          .getBoundingClientRect().top;
      }
    });
  },
  watch: {
    $route: {
      handler: function (route) {
        if (route.path !== '/dashboard' && route.path !== '/') {
          let payload = { to: route.path, name: route.name };
          this.$store.dispatch('addTab', payload);
          this.activeTab = route;
          localStorage.setItem('activeTab', JSON.stringify(payload));
        }
      },
      deep: true,
      immediate: true,
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu);
      } else {
        document.body.removeEventListener('click', this.closeMenu);
      }
    },
  },
  methods: {
    closeOthersTabs() {
      this.$store.dispatch(CLOSE_OTHER_TABS, this.activeTab);
    },

    openMenu(tag, e) {
      const menuMinWidth = 130;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const offsetWidth = this.$el.offsetWidth; // container width
      const maxLeft = offsetWidth - menuMinWidth; // left boundary
      const left = e.clientX - offsetLeft + 15; // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }

      this.top = e.clientY;
      this.visible = true;
      this.selectedTab = tag;
    },
    closeMenu() {
      this.visible = false;
    },
    deletetab(item) {
      let app = this;
      let indexOfDelete = this.tabs.findIndex((v) => v.to === item.to);
      this.$store.dispatch(REMOVE_TAB, item).then(() => {
        if (this.$route.path === item.to) {
          if (this.$store.getters.tabs.length) {
            if (this.$store.getters.tabs[indexOfDelete - 1] != undefined) {
              setTimeout(() => {
                app.$router.replace(this.tabs[indexOfDelete - 1].to);
                let sendObj = {
                  to: this.tabs[indexOfDelete - 1]['to'],
                  name: this.tabs[indexOfDelete - 1]['name'],
                };
                localStorage.setItem('activeTab', JSON.stringify(sendObj));
              }, 300);
            } else {
              setTimeout(() => {
                app.$router.replace(this.tabs[indexOfDelete].to);
                let sendObj = {
                  to: this.tabs[indexOfDelete]['to'],
                  name: this.tabs[indexOfDelete]['name'],
                };
                localStorage.setItem('activeTab', JSON.stringify(sendObj));
              }, 300);
            }
          } else {
            setTimeout(() => {
              app.$router.replace('/dashboard');
              localStorage.removeItem('activeTab');
            }, 300);
          }
        }
      });
    },

    defineTabsPosition() {
      this.visible = false;
      let scrollY = Math.round(window.scrollY);

      let tabsElement = document.querySelector('.main-tabs');
      if (scrollY > this.originalTabTop + 20) {
        tabsElement.classList.add('tabs-sticky');
      } else {
        tabsElement.classList.remove('tabs-sticky');
      }
    },
  },
  computed: {
    ...mapGetters(['tabs']),
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 12px;
}

.tabs-sticky {
  position: sticky;
  top: 5rem;
  z-index: 10;
  box-shadow: 0px 2px 4px -1px rgba(66, 66, 66, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);

  @media (max-width: 991.98px) {
    & {
      top: 4.7rem;
    }
  }
}
.scroll-container {
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  width: 100%;
}
.scroll-container .scrollbar__wrap {
  height: 55px;
}
.tags-view-container .tags-view-wrapper .tags-view-item {
  background: hsl(210deg 85% 95%);
  color: hsl(210deg 70% 65%);
  border-radius: 0.4rem;
  display: inline-block;
  position: relative;
  cursor: pointer;
  height: 26px;
  line-height: 26px;
  padding: 0 8px;
  font-size: 12px;
  margin-left: 0px;
  margin-top: 4px;
  .close-tab-icon {
    margin-right: 2px;
    padding: 3px 7px;
    border-radius: 50%;
    transition: all 0.2s ease-in-out;
    & i {
      color: hsl(210deg 100% 80%);
      font-size: 0.6rem;
      display: inline-block;
      transition: transform 0.08s ease-in;
    }
    &:hover i {
      will-change: transform;
      color: hsl(210deg 100% 70%);
      transform: scale(1.1);
    }
  }

  &.router-link-active,
  &.router-link-exact-active {
    background: hsl(210deg 75% 70%);
    color: hsl(210deg 100% 100%);
    font-weight: 500;

    /* box-shadow: 0 1px 10px 3px #79797938; */
    & .close-tab-icon i {
      color: hsl(210deg 100% 90%);
    }
    & .close-tab-icon:hover i {
      color: hsl(210deg 100% 97%);
      transform: scale(1.1);
    }
  }
}

.tags-view-container {
  margin-top: 0.8rem;
  height: 45px;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  .tags-view-wrapper {
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 35px;
      line-height: 32px;
      padding: 0 8px;
      font-size: 12px;
      margin-left: 5px;
      margin-top: 4px;
      &:first-of-type {
        margin-right: 23px;
      }
    }
  }
  @media (max-width: 991.98px) {
    & {
      margin-top: 0rem;
    }
  }
}
.contextmenu {
  margin: 0;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  font-size: 12px;
  font-weight: 400;
  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;
  }
}

.scrollbar__view {
  overflow-x: scroll;
  -webkit-padding-after: 0.3rem;
}

.scrollbar__view::-webkit-scrollbar {
  display: block;
  width: 3px !important;
  height: 6px !important;
}
.scrollbar__view::-webkit-scrollbar-track {
  background: transparent;
}

.scrollbar__view::-webkit-scrollbar-thumb {
  border-radius: 10px;
  height: 3px !important;
  width: 3px !important;
  margin-top: 0.3rem;
  background: -webkit-linear-gradient(
    hsl(210deg, 30%, 70%),
    hsl(210deg, 30%, 75%)
  );
}

.scrollbar__view::-webkit-scrollbar-track-piece:end {
  background: transparent;
  margin-bottom: 10px;
}

.scrollbar__view::-webkit-scrollbar-track-piece:start {
  background: transparent;
  margin-top: 10px;
}
</style>